export default {
  $schema: 'http://json-schema.org/draft-04/schema#',
  type: 'object',
  properties: {
    timezone: {
      type: 'string',
    },
  },
  required: ['timezone'],
}
